export function compareExpDate(exp: string | null): boolean {
  return !!exp && Number(exp) < Date.now();
}
